import {
  Avatar,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import Skelet from "../Skelet";
import PropTypes from "prop-types";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useDatabase } from "../../contexts/DatabaseContext";


function Accomplished(props) {
  const { isAdmin, uid, invited, achievements } = props;
  const { removeAchievement } = useDatabase();

  let data = <Skelet />;

  let handleDelete = (id) => {
    removeAchievement(uid, id);
  };

  let renderAccomplished = (docs) => {
    return docs.map((doc, i) => {

      return (
        <ListItem
          key={i}
          alignItems="flex-start"
          secondaryAction={

            doc.data().active ? (isAdmin ? (
                  <IconButton
                      onClick={() => {
                        handleDelete(doc.id);
                      }}
                      edge="end"
                      aria-label="delete"
                  >
                    <DeleteIcon />
                  </IconButton>
              ) : null) : null



          }
        >
          <ListItemAvatar>
            <Avatar src={doc.data().image} />
          </ListItemAvatar>
          <ListItemText
            primary={doc.data().name}
            secondary={
              <React.Fragment>{`${doc.data().points} баллов`}</React.Fragment>
            }
          />
        </ListItem>
      );
    });
  };



  try {
    data = renderAccomplished(achievements);
  } catch (e) {}

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography
          fontFamily="Mossport"
          sx={{ fontSize: 25 }}
          color="text.secondary"
          gutterBottom
        >
          ВЫПОЛНЕНО
        </Typography>
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar src="https://firebasestorage.googleapis.com/v0/b/gto-container.appspot.com/o/friend.png?alt=media&token=419aae54-8ee4-4d4c-b1e4-179d8d104c7b" />
            </ListItemAvatar>
            <ListItemText
              primary={"Пригласить друзей"}
              secondary={
                <React.Fragment>{`${invited * 10} баллов`}</React.Fragment>
              }
            />
          </ListItem>
          {data}
        </List>
      </CardContent>
    </Card>
  );
}

Accomplished.propTypes = {
  isAdmin: PropTypes.any,
  uid: PropTypes.any,
  invited: PropTypes.any,
};

export default Accomplished;
